import { useState } from "react"
import { useTranslations } from "next-intl"

import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "./pagination"

export const DataPagination = ({
  initialPage,
  totalPages,
  onPageChange,
}: {
  initialPage: number
  totalPages: number
  onPageChange: (page: number) => void
}) => {
  const t = useTranslations("storefront")
  const createPageClickHandler = (page: number) => (e: React.MouseEvent) => {
    e.preventDefault()
    setCurrentPage(page)
    onPageChange(page)
    window?.scrollTo({ top: 0, behavior: "smooth" })
  }
  const [currentPage, setCurrentPage] = useState(initialPage)
  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href="#"
            title={t("pagination.previous")}
            onClick={createPageClickHandler(currentPage - 1)}
            className={currentPage === 1 ? "pointer-events-none opacity-50" : ""}
          />
        </PaginationItem>

        {/* Optional: Add ellipsis if currentPage is far from 1 */}
        {currentPage > 2 && (
          <>
            <PaginationItem>
              <PaginationLink href="#" onClick={createPageClickHandler(1)}>
                1
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>
          </>
        )}

        {/* Page Numbers */}
        {[currentPage - 1, currentPage, currentPage + 1]
          .filter((p) => p > 0 && p <= totalPages)
          .map((page) => (
            <PaginationItem key={page}>
              <PaginationLink href="#" isActive={page === currentPage} onClick={createPageClickHandler(page)}>
                {page}
              </PaginationLink>
            </PaginationItem>
          ))}

        {/* Optional: Add ellipsis if not near the last page */}
        {currentPage < totalPages - 1 && (
          <>
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#" onClick={createPageClickHandler(totalPages)}>
                {totalPages}
              </PaginationLink>
            </PaginationItem>
          </>
        )}

        <PaginationItem>
          <PaginationNext
            href="#"
            title={t("pagination.next")}
            onClick={createPageClickHandler(currentPage + 1)}
            className={currentPage === totalPages ? "pointer-events-none opacity-50" : ""}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
